module.exports = __webpack_public_path__ + "img/hzm-bottom.5ac87afa.png";